<template>
    <div class="col-md-12">
        <br />
        <div class="ln_solid"></div>
        <div class="alert alert-info">
            {{ description }}
        </div>
        <div class="ln_solid"></div>
        <b-tabs pills card>
            <b-tab title="Documents">
                <br />
                <form class="form-inline" @submit.prevent="searchData()" role="form">
                    <div class="form-group">
                        <input type="date"
                               class="form-control input-sm"
                               v-model="pagingInfo.datestart"
                               placeholder="Start Date" />

                        <input type="date"
                               class="form-control input-sm"
                               v-model="pagingInfo.dateend"
                               placeholder="End Date" />

                        <input type="text"
                               class="form-control input-sm"
                               v-model="pagingInfo.search"
                               placeholder="Subject/Title" />

                        <button type="submit" class="btn btn-info">
                            <strong>Search</strong>
                        </button>
                    </div>
                </form>
                <br />

                <div class="box">
                    <div class="box-header"></div>
                    <div class="box-body table-responsive no-padding">
                        <table class="table table-hover">
                            <thead>
                                <tr>
                                    <th>
                                        <a @click="sort('SubjectTitle')">Subject</a>
                                    </th>
                                    <th>SourceName</th>
                                    <th>Report No.</th>
                                    <th>ReportName</th>
                                    <th>
                                        <a @click="sort('ReportDate')">ReportDate</a>
                                    </th>
                                    <th>Comments</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="doc in docs" :key="doc.id">
                                    <td>{{ doc.subject | capitalize }}</td>
                                    <td>{{ doc.sourcename }}</td>
                                    <td>{{ doc.reportnum }}</td>
                                    <td>{{ doc.reportname }}</td>
                                    <td>{{ doc.reportdate | formatDate }}</td>
                                    <td>{{ doc.comments }}</td>
                                    <td>
                                        <TheDropDownButton>
                                            <btn @click.native="getfile(doc.id)"
                                                 icon="fa fa-download"
                                                 title="Download File"></btn>
                                            <btn @click.native="addSelected(doc)"
                                                 icon="fa fa-plus"
                                                 title="Add to download list"></btn>
                                            <btn v-if="$store.getters.CRAD"
                                                 @click.native="deleteLinkSingle(doc.pid)"
                                                 icon="fa fa-unlink"
                                                 title="Unlink"></btn>
                                            <btn @click.native="preview(doc.id)"
                                                 icon="fa fa-search"
                                                 title="Preview File Attached"></btn>
                                        </TheDropDownButton>
                                    </td>
                                </tr>
                            </tbody>
                            <tfoot></tfoot>
                        </table>
                        <div v-show="totalitemsdoc == 0" class="alert alert-warning">
                            <p>Found no result try again</p>
                        </div>
                        
                    </div>
                </div>

                <b-pagination v-model="pagingInfo.page"
                              v-on:input="fetchData()"
                              :total-rows="totalitemsdoc"
                              :per-page="pagingInfo.itemsPerPage"
                              first-text="First"
                              prev-text="Prev"
                              next-text="Next"
                              last-text="Last"></b-pagination>
                <input id="download4"
                       v-show="docs.length > 0"
                       @click="downloadDisplayed()"
                       type="button"
                       value="Download Displayed Record"
                       class="btn btn-sm btn-primary" />&nbsp;
                <input id="download1"
                       v-show="toDownload.length > 0"
                       @click="downloadSelected()"
                       type="button"
                       value="Download Selected Record"
                       class="btn btn-sm btn-success" />&nbsp;
                <input id="download2"
                       v-show="toDownload.length > 0"
                       @click="editSelected()"
                       type="button"
                       value="Edit Selected Record"
                       class="btn btn-sm btn-warning" />&nbsp;
                <input id="download3"
                       v-show="toDownload.length > 0"
                       @click="clearSelected()"
                       type="button"
                       value="Clear Selected Record/s"
                       class="btn btn-sm btn-danger" />
                <br />
                <img v-show="submitted"
                     src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
                <span>
                    <p>Total Documents to download : {{ toDownload.length }}</p>
                </span>
            </b-tab>
            <b-tab title="Persons">
                <br />
                <form class="form-inline" @submit.prevent="searchPerson()" role="form">
                    <button type="submit" class="btn btn-info">
                        <strong>Load Links</strong>
                    </button>
                </form>
                <br />

                <div class="box">
                    <div class="box-header"></div>
                    <div class="box-body table-responsive no-padding">
                        <table class="table table-hover">
                            <thead>
                                <tr>
                                    <th>LastName</th>
                                    <th>FirstName</th>
                                    <th>Suffix</th>
                                    <th>MiddleName</th>
                                    <th>Alias</th>
                                    <th>Comments</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="doc in persons" :key="doc.id">
                                    <td>{{ doc.lastname | capitalize }}</td>
                                    <td>{{ doc.firstname | capitalize }}</td>
                                    <td>{{ doc.namesuffix | capitalize }}</td>
                                    <td>{{ doc.middlename | capitalize }}</td>
                                    <td>{{ doc.alias | capitalize }}</td>
                                    <td>{{ doc.data }}</td>
                                    <td>
                                        <TheDropDownButton>
                                            <btn @click.native="soidb(doc.id, 'PN')"
                                                 icon="fa fa-file"
                                                 title="View SOI from database"></btn>
                                            <btn @click.native="sois(doc.id)"
                                                 icon="fa fa-download"
                                                 title="View Downloadable Profile"></btn>
                                            <!-- <btn
                                              @click.native="more(doc, 'PN')"
                                              icon="fa fa-expand-alt"
                                              title="View Linkages"
                                            ></btn> -->
                                            <btn v-if="$store.getters.CRAD"
                                                 @click.native="deleteLinkSingle(doc.id)"
                                                 icon="fa fa-unlink"
                                                 title="Unlink"></btn>
                                        </TheDropDownButton>
                                    </td>
                                </tr>
                            </tbody>
                            <tfoot></tfoot>
                        </table>
                        <div v-show="totalitemsperson == 0" class="alert alert-warning">
                            <p>Found no result try again</p>
                        </div>
                    </div>
                </div>

                <b-pagination v-model="pagingInfoPerson.page"
                              v-on:input="fetchPerson()"
                              :total-rows="totalitemsperson"
                              :per-page="pagingInfoPerson.itemsPerPage"
                              first-text="First"
                              prev-text="Prev"
                              next-text="Next"
                              last-text="Last"></b-pagination>
            </b-tab>
            <b-tab title="Organizations">
                <br />
                <form class="form-inline"
                      @submit.prevent="searchOrganization()"
                      role="form">
                    <button type="submit" class="btn btn-info">
                        <strong>Load Links</strong>
                    </button>
                </form>

                <div class="box">
                    <div class="box-header"></div>
                    <div class="box-body table-responsive no-padding">
                        <table class="table table-hover">
                            <thead>
                                <tr>
                                    <th>Name</th>
                                    <th>OtherName</th>
                                    <th>Comments</th>
                                    <th>Country</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="doc in organizations" :key="doc.id">
                                    <td>{{ doc.name | capitalize }}</td>
                                    <td>{{ doc.othername | capitalize }}</td>
                                    <td>{{ doc.comments | capitalize }}</td>
                                    <td>{{ doc.country }}</td>
                                    <td>
                                        <TheDropDownButton>
                                            <btn @click.native="soidb(doc.id, 'OG')"
                                                 icon="fa fa-file"
                                                 title="View SOI from database"></btn>&nbsp;
                                            <btn @click.native="sois(doc.id)"
                                                 icon="fa fa-download"
                                                 title="View Downloadable Profile"></btn>&nbsp;
                                            <!-- <btn
                                              @click.native="more(doc, 'OG')"
                                              icon="fa fa-expand-alt"
                                              title="View Linkages"
                                            ></btn> -->
                                            <btn v-if="$store.getters.CRAD"
                                                 @click.native="deleteLinkSingle(doc.id)"
                                                 icon="fa fa-unlink"
                                                 title="Unlink"></btn>
                                        </TheDropDownButton>
                                    </td>
                                </tr>
                            </tbody>
                            <tfoot></tfoot>
                        </table>
                        <div v-show="totalitemsorg == 0" class="alert alert-warning">
                            <p>Found no result try again</p>
                        </div>
                    </div>
                </div>

                <b-pagination v-model="pagingInfoOrganization.page"
                              v-on:input="fetchOrganization()"
                              :total-rows="totalitemsorg"
                              :per-page="pagingInfoOrganization.itemsPerPage"
                              first-text="First"
                              prev-text="Prev"
                              next-text="Next"
                              last-text="Last"></b-pagination>
            </b-tab>
            <b-tab title="Events">
                <br />
                <form class="form-inline" @submit.prevent="searchEvents()" role="form">
                    <button type="submit" class="btn btn-info">
                        <strong>Load Links</strong>
                    </button>
                </form>

                <div class="box">
                    <div class="box-header"></div>
                    <div class="box-body table-responsive no-padding">
                        <table class="table table-hover">
                            <thead>
                                <tr>
                                    <th>Type</th>
                                    <th>Subject</th>
                                    <th>
                                        <a @click="sortev('DateStart')">Started</a>
                                    </th>
                                    <th>
                                        <a @click="sortev('DateEnd')">Ended</a>
                                    </th>
                                    <th>Comments</th>
                                    <th>Country</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="doc in events" :key="doc.id">
                                    <td>{{ doc.type | capitalize }}</td>
                                    <td>{{ doc.subject | capitalize }}</td>
                                    <td>{{ doc.datestarted | formatDate }}</td>
                                    <td>{{ doc.dateended | formatDate }}</td>
                                    <td>{{ doc.comments | capitalize }}</td>
                                    <td>{{ doc.country }}</td>
                                    <td>
                                        <TheDropDownButton>
                                            <!-- <btn
                                              @click.native="more(doc, 'EV')"
                                              icon="fa fa-expand-alt"
                                              title="View Linkages"
                                            ></btn> -->
                                            <btn v-if="$store.getters.CRAD"
                                                 @click.native="deleteLinkSingle(doc.id)"
                                                 icon="fa fa-unlink"
                                                 title="Unlink"></btn>
                                        </TheDropDownButton>
                                    </td>
                                </tr>
                            </tbody>
                            <tfoot></tfoot>
                        </table>
                        <div v-show="totalitemsevents == 0" class="alert alert-warning">
                            <p>Found no result try again</p>
                        </div>
                    </div>
                </div>

                <b-pagination v-model="pagingInfoEvents.page"
                              v-on:input="fetchEvents()"
                              :total-rows="totalitemsevents"
                              :per-page="pagingInfoEvents.itemsPerPage"
                              first-text="First"
                              prev-text="Prev"
                              next-text="Next"
                              last-text="Last"></b-pagination>
            </b-tab>
            <b-tab title="Financial">
                <br />
                <form class="form-inline"
                      @submit.prevent="searchFinancial()"
                      role="form">
                    <button type="submit" class="btn btn-info">
                        <strong>Load Links</strong>
                    </button>
                </form>
                <div class="box">
                    <div class="box-header"></div>
                    <div class="box-body table-responsive no-padding">
                        <table class="table table-hover">
                            <thead>
                                <tr>
                                    <th>Type</th>
                                    <th>Account No.</th>
                                    <th>Company</th>
                                    <th>Comments</th>
                                    <th>Country</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="fr in financial" :key="fr.id">
                                    <td>{{ fr.type }}</td>
                                    <td>{{ fr.accountno | capitalize }}</td>
                                    <td>{{ fr.company | capitalize }}</td>
                                    <td>{{ fr.comments | capitalize }}</td>
                                    <td>{{ fr.country }}</td>
                                    <td>
                                        <TheDropDownButton>
                                            <!-- <btn
                                              @click.native="more(fr, 'FR')"
                                              icon="fa fa-expand-alt"
                                              title="View Linkages"
                                            ></btn> -->
                                            <btn v-if="$store.getters.CRAD"
                                                 @click.native="deleteLinkSingle(fr.id)"
                                                 icon="fa fa-unlink"
                                                 title="Unlink"></btn>
                                        </TheDropDownButton>
                                    </td>
                                </tr>
                            </tbody>
                            <tfoot></tfoot>
                        </table>
                        <div v-show="totalitemsfinancial == 0" class="alert alert-warning">
                            <p>Found no result try again</p>
                        </div>
                    </div>
                </div>
            </b-tab>
            <b-tab title="FireArms">
                <br />
                <form class="form-inline"
                      @submit.prevent="searchFirearms()"
                      role="form">
                    <button type="submit" class="btn btn-info">
                        <strong>Load Links</strong>
                    </button>
                </form>
                <div class="box">
                    <div class="box-header"></div>
                    <div class="box-body table-responsive no-padding">
                        <table class="table table-hover">
                            <thead>
                                <tr>
                                    <th>SerialNo.</th>
                                    <th>Make</th>
                                    <th>Caliber</th>
                                    <th>Model</th>
                                    <th>Comments</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="fa in firearms" :key="fa.id">
                                    <td>{{ fa.serialno }}</td>
                                    <td>{{ fa.make }}</td>
                                    <td>{{ fa.caliber }}</td>
                                    <td>{{ fa.model }}</td>
                                    <td>{{ fa.comments }}</td>
                                    <td>
                                        <TheDropDownButton>
                                            <!-- <btn
                                              @click.native="more(fa, 'FA')"
                                              icon="fa fa-expand-alt"
                                              title="View Linkages"
                                            ></btn> -->
                                            <btn v-if="$store.getters.CRAD"
                                                 @click.native="deleteLinkSingle(fa.id)"
                                                 icon="fa fa-unlink"
                                                 title="Unlink"></btn>
                                        </TheDropDownButton>
                                    </td>
                                </tr>
                            </tbody>
                            <tfoot></tfoot>
                        </table>
                        <div v-show="totalitemsfirearm == 0" class="alert alert-warning">
                            <p>Found no result try again</p>
                        </div>
                    </div>
                </div>
            </b-tab>
            <b-tab title="LegalCharges">
                <br />
                <form class="form-inline"
                      @submit.prevent="searchLegalCharges()"
                      role="form">
                    <button type="submit" class="btn btn-info">
                        <strong>Load Links</strong>
                    </button>
                </form>
                <div class="box">
                    <div class="box-header"></div>
                    <div class="box-body table-responsive no-padding">
                        <table class="table table-hover">
                            <thead>
                                <tr>
                                    <th>Charge</th>
                                    <th>ReferenceNo.</th>
                                    <th>Authority</th>
                                    <th>Charge Date</th>
                                    <th>Comments</th>
                                    <th>Country</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="lc in legalcharges" :key="lc.id">
                                    <td>{{ lc.charge }}</td>
                                    <td>{{ lc.referenceno }}</td>
                                    <td>{{ lc.authority }}</td>
                                    <td>{{ lc.chargedate | formatDate }}</td>
                                    <td>{{ lc.comments }}</td>
                                    <td>{{ lc.country }}</td>
                                    <td>
                                        <TheDropDownButton>
                                            <!-- <btn
                                              @click.native="more(lc, 'LC')"
                                              icon="fa fa-expand-alt"
                                              title="View Linkages"
                                            ></btn> -->
                                            <btn v-if="$store.getters.CRAD"
                                                 @click.native="deleteLinkSingle(lc.id)"
                                                 icon="fa fa-unlink"
                                                 title="Unlink"></btn>
                                        </TheDropDownButton>
                                    </td>
                                </tr>
                            </tbody>
                            <tfoot></tfoot>
                        </table>
                        <div v-show="totalitemslegalcharges == 0"
                             class="alert alert-warning">
                            <p>Found no result try again</p>
                        </div>
                    </div>
                </div>
            </b-tab>
            <b-tab title="RealEstate">
                <br />
                <form class="form-inline"
                      @submit.prevent="searchRealEstate()"
                      role="form">
                    <button type="submit" class="btn btn-info">
                        <strong>Load Links</strong>
                    </button>
                </form>
                <div class="box">
                    <div class="box-header"></div>
                    <div class="box-body table-responsive no-padding">
                        <table class="table table-hover">
                            <thead>
                                <tr>
                                    <th>Type</th>
                                    <th>RegisterNo.</th>
                                    <th>Comments</th>
                                    <th>Country</th>
                                    <th>State</th>
                                    <th>City</th>
                                    <th>Address</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="re in realestate" :key="re.id">
                                    <td>{{ re.type }}</td>
                                    <td>{{ re.registerno }}</td>
                                    <td>{{ re.comments }}</td>
                                    <td>{{ re.country }}</td>
                                    <td>{{ re.state }}</td>
                                    <td>{{ re.city }}</td>
                                    <td>{{ re.address }}</td>
                                    <td>
                                        <TheDropDownButton>
                                            <!-- <btn
                                              @click.native="more(re, 'RE')"
                                              icon="fa fa-expand-alt"
                                              title="View Linkages"
                                            ></btn> -->
                                            <btn v-if="$store.getters.CRAD"
                                                 @click.native="deleteLinkSingle(re.id)"
                                                 icon="fa fa-unlink"
                                                 title="Unlink"></btn>
                                        </TheDropDownButton>
                                    </td>
                                </tr>
                            </tbody>
                            <tfoot></tfoot>
                        </table>
                        <div v-show="totalitemsrealestate == 0" class="alert alert-warning">
                            <p>Found no result try again</p>
                        </div>
                    </div>
                </div>
            </b-tab>
            <b-tab title="Telephone">
                <br />
                <form class="form-inline"
                      @submit.prevent="searchTelephone()"
                      role="form">
                    <button type="submit" class="btn btn-info">
                        <strong>Load Links</strong>
                    </button>
                </form>
                <div class="box">
                    <div class="box-header"></div>
                    <div class="box-body table-responsive no-padding">
                        <table class="table table-hover">
                            <thead>
                                <tr>
                                    <th>Type</th>
                                    <th>PhoneNo.</th>
                                    <th>Comments</th>
                                    <th>Country</th>
                                    <th>State</th>
                                    <th>City</th>
                                    <th>IMSI</th>
                                    <th>Address</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="te in telephone" :key="te.id">
                                    <td>{{ te.type }}</td>
                                    <td>{{ te.registerno }}</td>
                                    <td>{{ te.comments }}</td>
                                    <td>{{ te.country }}</td>
                                    <td>{{ te.state }}</td>
                                    <td>{{ te.city }}</td>
                                    <td>{{ te.imsi }}</td>
                                    <td>{{ te.address }}</td>
                                    <td>
                                        <TheDropDownButton>
                                            <!-- <btn
                                              @click.native="more(te, 'TE')"
                                              icon="fa fa-expand-alt"
                                              title="View Linkages"
                                            ></btn> -->
                                            <btn v-if="$store.getters.CRAD"
                                                 @click.native="deleteLinkSingle(te.id)"
                                                 icon="fa fa-unlink"
                                                 title="Unlink"></btn>
                                        </TheDropDownButton>
                                    </td>
                                </tr>
                            </tbody>
                            <tfoot></tfoot>
                        </table>
                        <div v-show="totalitemstelephone == 0" class="alert alert-warning">
                            <p>Found no result try again</p>
                        </div>
                    </div>
                </div>
            </b-tab>
            <b-tab title="Official Papers">
                <br />
                <form class="form-inline" @submit.prevent="searchPapers()" role="form">
                    <button type="submit" class="btn btn-info">
                        <strong>Load Links</strong>
                    </button>
                </form>
                <div class="box">
                    <div class="box-header"></div>
                    <div class="box-body table-responsive no-padding">
                        <table class="table table-hover">
                            <thead>
                                <tr>
                                    <th>Type</th>
                                    <th />
                                    <th>ReferenceNo.</th>
                                    <th>Country</th>
                                    <th>IssuingAgency</th>
                                    <th>IssuanceDate</th>
                                    <th>Comments</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="pr in papers" :key="pr.id">
                                    <td>{{ pr.type }}</td>
                                    <td>{{ pr.referenceno }}</td>
                                    <td>{{ pr.country }}</td>
                                    <td>{{ pr.issuingagency }}</td>
                                    <td>{{ pr.issuancedate | formatDate }}</td>
                                    <td>{{ pr.comments }}</td>
                                    <td>
                                        <TheDropDownButton>
                                            <!-- <btn
                                              @click.native="more(pr, 'PR')"
                                              icon="fa fa-expand-alt"
                                              title="View Linkages"
                                            ></btn> -->
                                            <btn v-if="$store.getters.CRAD"
                                                 @click.native="deleteLinkSingle(pr.id)"
                                                 icon="fa fa-unlink"
                                                 title="Unlink"></btn>
                                        </TheDropDownButton>
                                    </td>
                                </tr>
                            </tbody>
                            <tfoot></tfoot>
                        </table>
                        <div v-show="totalitemspaper == 0" class="alert alert-warning">
                            <p>Found no result try again</p>
                        </div>
                    </div>
                </div>
            </b-tab>
            <b-tab title="Transportation">
                <br />
                <form class="form-inline"
                      @submit.prevent="searchTransportation()"
                      role="form">
                    <button type="submit" class="btn btn-info">
                        <strong>Load Links</strong>
                    </button>
                </form>
                <div class="box">
                    <div class="box-header"></div>
                    <div class="box-body table-responsive no-padding">
                        <table class="table table-hover">
                            <thead>
                                <tr>
                                    <th>Type</th>
                                    <th>PricipalID.</th>
                                    <th>Name</th>
                                    <th>AdditionalID</th>
                                    <th>Make</th>
                                    <th>Model</th>
                                    <th>Country</th>
                                    <th>ModelYear</th>
                                    <th>Color</th>
                                    <th>Comments</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="tr in transportation" :key="tr.id">
                                    <td>{{ tr.type }}</td>
                                    <td>{{ tr.principalid }}</td>
                                    <td>{{ tr.name }}</td>
                                    <td>{{ tr.additionalid }}</td>
                                    <td>{{ tr.make }}</td>
                                    <td>{{ tr.model }}</td>
                                    <td>{{ tr.country }}</td>
                                    <td>{{ tr.modelyear }}</td>
                                    <td>{{ tr.color }}</td>
                                    <td>{{ tr.comments }}</td>
                                    <td>
                                        <TheDropDownButton>
                                            <!-- <btn
                                              @click.native="more(tr, 'TR')"
                                              icon="fa fa-expand-alt"
                                              title="View Linkages"
                                            ></btn> -->
                                            <btn v-if="$store.getters.CRAD"
                                                 @click.native="deleteLinkSingle(tr.id)"
                                                 icon="fa fa-unlink"
                                                 title="Unlink"></btn>
                                        </TheDropDownButton>
                                    </td>
                                </tr>
                            </tbody>
                            <tfoot></tfoot>
                        </table>
                        <div v-show="totalitemstransportation == 0"
                             class="alert alert-warning">
                            <p>Found no result try again</p>
                        </div>
                    </div>
                </div>
            </b-tab>
        </b-tabs>
        <!-- modal for viewing of selected records -->
        <div>
            <b-modal id="selectedddocuments"
                     title="Documents to download"
                     size="lg"
                     scrollable
                     hide-footer>
                <table class="table table-bordered table-responsive">
                    <thead>
                        <tr>
                            <th>Subject</th>
                            <th>Source Name</th>
                            <th>Report Number</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="items in selected" :key="items.ID">
                            <td hidden>{{ items.ID }}</td>
                            <td>{{ items.SUBJECT }}</td>
                            <td>{{ items.SOURCENAME }}</td>
                            <td>{{ items.REPORTNUMBER }}</td>
                            <td>
                                <button class="btn btn-xs btn-danger"
                                        @click="removeSelected(items)">
                                    Remove
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </b-modal>
        </div>
        <!-- Modal For Uploaded SOI -->
        <div>
            <b-modal id="soilists" title="Uploaded SOI" scrollable hide-footer>
                <TheSoiProfileLink v-bind:id="soiId" />
            </b-modal>
        </div>
        <div>
            <b-modal id="soifromdbs"
                     title="FullText SOI"
                     scrollable
                     hide-footer
                     size="xl">
                <span v-html="soifromdb"></span>
            </b-modal>
        </div>
        <div>
            <b-modal id="previewlink"
                     title="Preview"
                     scrollable
                     hide-footer
                     size="xl">
                <viewerlink v-bind:Id="idforviewer"
                            v-bind:html="htmlforviewer" />
            </b-modal>
        </div>
    </div>
</template>

<script>
    import {
        authHeader,
        responseCheck,
        RecordURL,
        authHeaderjson,
        notifyHelper,
        downloadblob,
        DataURL
    } from "../helper";
    import btn from "./buttons/iconButton";
    import TheSoiProfileLink from "./master/soiProfile";
    import instance from "../helper/http";
    import viewerlink from "./master/viewer";
    export default {
        components: {
            btn,
            TheSoiProfileLink,
            viewerlink
        },
        data() {
            return {
                soifromdb: "",
                soi: [],
                soiId: "",
                submitted: false,
                toDownload: [],
                selected: [],
                docs: [],
                htmlforviewer: "",
                idforviewer: "",
                selectalldocs: false,
                pagingInfo: {
                    id: null,
                    page: 1,
                    sortBy: "",
                    reverse: false,
                    datestart: "",
                    dateend: "",
                    search: "",
                },
                description: null,
                totalitemsdoc: null,
                persons: [],
                pagingInfoPerson: {
                    id: null,
                    page: 1,

                    sortBy: "LastName",
                    reverse: false,
                },
                totalitemsperson: null,
                organizations: [],
                pagingInfoOrganization: {
                    id: null,
                    page: 1,

                    sortBy: "Name",
                    reverse: false,
                },
                totalitemsorg: null,
                events: [],
                pagingInfoEvents: {
                    id: null,
                    page: 1,

                    sortBy: "DateStart",
                    reverse: false,
                },
                totalitemsevents: null,
                financial: [],
                pagingInfoFinancial: {
                    id: null,
                    page: 1,

                    sortBy: "DateStart",
                    reverse: false,
                },
                totalitemsfinancial: null,
                firearms: [],
                pagingInfoFirearms: {
                    id: null,
                    page: 1,

                    sortBy: "DateStart",
                    reverse: false,
                },
                totalitemsfirearm: null,
                legalcharges: [],
                pagingInfoLegalCharges: {
                    id: null,
                    page: 1,

                    sortBy: "DateStart",
                    reverse: false,
                },
                totalitemslegalcharges: null,
                realestate: [],
                pagingInfoRealEstates: {
                    id: null,
                    page: 1,

                    sortBy: "DateStart",
                    reverse: false,
                },
                totalitemsrealestate: null,
                telephone: [],
                pagingInfoTelephone: {
                    id: null,
                    page: 1,

                    sortBy: "DateStart",
                    reverse: false,
                },
                totalitemstelephone: null,
                papers: [],
                pagingInfoPapers: {
                    id: null,
                    page: 1,

                    sortBy: "DateStart",
                    reverse: false,
                },
                totalitemspaper: null,
                transportation: [],
                pagingInfoTransportation: {
                    id: null,
                    page: 1,

                    sortBy: "DateStart",
                    reverse: false,
                },
                totalitemstransportation: null,
            };
        },
        watch: {
            "$route.params.id": function (id) {
                this.pagingInfo.id = id;
                this.pagingInfoPerson.id = id;
                this.pagingInfoOrganization.id = id;
                this.pagingInfoEvents.id = id;
                this.pagingInfoFinancial.id = id;
                this.pagingInfoFirearms.id = id;
                this.pagingInfoLegalCharges.id = id;
                this.pagingInfoRealEstates.id = id;
                this.pagingInfoTelephone.id = id;
                this.pagingInfoPapers.id = id;
                this.pagingInfoTransportation.id = id;
            },
            "$route.params.description": function (description) {
                this.description = description;
            },
        },
        created: function () {
            this.description = this.$route.params.description;
            this.pagingInfo.id = this.$route.params.id;
            this.pagingInfoPerson.id = this.$route.params.id;
            this.pagingInfoOrganization.id = this.$route.params.id;
            this.pagingInfoEvents.id = this.$route.params.id;
            this.pagingInfoFinancial.id = this.$route.params.id;
            this.pagingInfoFirearms.id = this.$route.params.id;
            this.pagingInfoLegalCharges.id = this.$route.params.id;
            this.pagingInfoRealEstates.id = this.$route.params.id;
            this.pagingInfoTelephone.id = this.$route.params.id;
            this.pagingInfoPapers.id = this.$route.params.id;
            this.pagingInfoTransportation.id = this.$route.params.id;
        },
        methods: {
            downloadSelected: function () {
                //buttondownload need to count the length of todownload show if there is an entry
                this.downloadReport();
            },
            preview(id) {
                instance
                    .get(DataURL + "preview?Id=" + id, {
                        headers: authHeader(),
                    })
                    .then((response) => {
                        if (!response.data.error) {
                            this.idforviewer = id;
                            this.htmlforviewer = response.data.data;
                            this.$bvModal.show("previewlink");
                        } else {
                            notifyHelper("info", response.data.message);
                        }
                    })
                    .catch(function (error) {
                        responseCheck(error.response.status);
                    });
            },
            downloadReport: function () {
                let downloads = JSON.stringify(this.selected);
                this.submitted = true;
                instance
                    .post(RecordURL + "files", downloads, {
                        headers: authHeaderjson(),
                    })
                    .then((response) => {
                        if (response.data.withfiles) {
                            this.toDownload = [];
                            this.selected = [];
                            this.downloadzip(response.data.data, response.data.type);
                        } else {
                            notifyHelper(
                                "info",
                                "Files are not available the file server might have been turned off!"
                            );
                        }
                    })
                    .catch(function (error) {
                        responseCheck(error.response.status);
                    })
                    .finally(() => (this.submitted = false));
            },
            downloadDisplayed: function () {
                this.docs.forEach((element) => {
                    this.selected.push({
                        ID: element.id,
                        SUBJECT: element.subject,
                        SOURCENAME: element.sourcename,
                        REPORTNUMBER: element.reportnum,
                    });
                });
                this.downloadReport();
            },
            downloadzip: function (filename, type) {
                let loader = this.$loading.show();
                instance
                    .get(RecordURL + "downloadzip?zip=" + filename, {
                        headers: authHeader(),
                        responseType: "blob",
                    })
                    .then((response) => {
                        downloadblob(filename, response.data, type);
                    })
                    .catch((error) => {
                        responseCheck(error.response.status);
                    })
                    .finally(() => loader.hide());
            },
            clearSelected: function () {
                //button clear need to count the length of todownload show if there is an entry
                if (confirm("clear selected/added report?")) {
                    this.toDownload = [];
                    this.selected = [];
                    this.selectalldocs = false;
                    notifyHelper("info", "Files to download cleared!");
                }
            },
            editSelected: function () {
                //modal
                if (this.toDownload.length > 0) {
                    this.$bvModal.show("selectedddocuments");
                }
            },
            addSelected: function (item) {
                for (let i = 0; i < this.toDownload.length; i++) {
                    if (this.toDownload[i].ID === item.id) {
                        notifyHelper("warn", "Document Already on the list!");
                        return;
                    }
                }
                this.toDownload.push({ ID: item.id });
                this.selected.push({
                    ID: item.id,
                    SUBJECT: item.subject,
                    SOURCENAME: item.sourcename,
                    REPORTNUMBER: item.reportnum,
                });
                notifyHelper("info", "Document Added to the download list!");
            },
            removeSelected: function (items) {
                this.toDownload = this.toDownload.filter((item) => item.ID !== items.ID);
                this.selected = this.selected.filter((item) => item.ID !== items.ID);
            },
            download: function (docID, filename, type) {
                let loader = this.$loading.show();
                instance
                    .get(RecordURL + "downloadcopy?docID=" + docID, {
                        headers: authHeader(),
                        responseType: "blob",
                    })
                    .then((response) => {
                        downloadblob(filename, response.data, type);
                        loader.hide();
                    })
                    .catch(function (error) {
                        responseCheck(error.response.status);
                    });
            },
            getfile: function (id) {
                instance
                    .get(RecordURL + "checkfiles?docID=" + id, {
                        headers: authHeader(),
                    })
                    .then((response) => {
                        if (response.data.withfiles) {
                            this.download(id, response.data.filename, response.data.type);
                        } else {
                            notifyHelper(
                                "info",
                                "Attached file not found or the file server was turned off!"
                            );
                        }
                    })
                    .catch(function (error) {
                        responseCheck(error.response.status);
                    });
            },
            fetchData() {
                instance
                    .get(RecordURL + "getlinkstodocument", {
                        headers: authHeader(),
                        params: this.pagingInfo,
                    })
                    .then((response) => {
                        this.docs = response.data.data;
                        this.totalitemsdoc = response.data.count;
                    })
                    .catch(function (error) {
                        responseCheck(error.response.status);
                    });
            },
            searchData() {
                this.pagingInfo.page = 1;
                this.fetchData();
            },
            more: function (data, type) {
                if (type === "DC") {
                    var additional = data.subject;
                    additional = additional.replace(/\//g, "-");
                    this.$router.replace({
                        name: "Links",
                        params: { id: data.id, description: additional },
                    });
                } else if (type === "PN") {
                    var additional1 =
                        data.firstname + data.middlename + data.lastname + data.alias;
                    additional1 = additional1.replace(/\//g, "-");
                    this.$router.replace({
                        name: "Links",
                        params: { id: data.id, description: additional1 },
                    });
                } else if (type === "OG") {
                    var additional2 = data.name;
                    additional2 = additional2.replace(/\//g, "-");
                    this.$router.replace({
                        name: "Links",
                        params: { id: data.id, description: additional2 },
                    });
                } else if (type === "EV") {
                    var additional3 = data.subject;
                    additional3 = additional3.replace(/\//g, "-");
                    this.$router.replace({
                        name: "Links",
                        params: { id: data.id, description: additional3 },
                    });
                } else if (type === "FR") {
                    var additional4 = data.accountno;
                    additional4 = additional4.replace(/\//g, "-");
                    this.$router.replace({
                        name: "Links",
                        params: { id: data.id, description: additional4 },
                    });
                } else if (type === "FA") {
                    var additional5 = data.serialno;
                    additional5 = additional5.replace(/\//g, "-");
                    this.$router.replace({
                        name: "Links",
                        params: { id: data.id, description: additional5 },
                    });
                } else if (type === "LC") {
                    var additional6 = data.charge;
                    additional6 = additional6.replace(/\//g, "-");
                    this.$router.replace({
                        name: "Links",
                        params: { id: data.id, description: additional6 },
                    });
                } else if (type === "RE") {
                    var additional7 = data.type;
                    additional7 = additional7.replace(/\//g, "-");
                    this.$router.replace({
                        name: "Links",
                        params: { id: data.id, description: additional7 },
                    });
                } else if (type == "TE") {
                    var additional8 = data.phoneno;
                    additional8 = additional8.replace(/\//g, "-");
                    this.$router.replace({
                        name: "Links",
                        params: { id: data.id, description: additional8 },
                    });
                } else if (type == "PR") {
                    var additional9 = data.type;
                    additional9 = additional9.replace(/\//g, "-");
                    this.$router.replace({
                        name: "Links",
                        params: { id: data.id, description: additional9 },
                    });
                } else if (type == "TR") {
                    var additional10 = data.name;
                    additional10 = additional10.replace(/\//g, "-");
                    this.$router.replace({
                        name: "Links",
                        params: { id: data.id, description: additional10 },
                    });
                }
            },
            sort: function (sortBy) {
                if (sortBy === this.pagingInfo.sortBy) {
                    this.pagingInfo.reverse = !this.pagingInfo.reverse;
                } else {
                    this.pagingInfo.sortBy = sortBy;
                    this.pagingInfo.reverse = false;
                }
                this.pagingInfo.page = 1;
                this.fetchData();
            },
            searchPerson() {
                this.pagingInfoPerson.page = 1;
                this.fetchPerson();
            },
            fetchPerson() {
                instance
                    .get(RecordURL + "getlinkstoperson", {
                        headers: authHeader(),
                        params: this.pagingInfoPerson,
                    })
                    .then((response) => {
                        this.persons = response.data.data;
                        this.totalitemsperson = response.data.count;
                    })
                    .catch(function (error) {
                        responseCheck(error.response.status);
                    });
            },
            searchOrganization() {
                this.pagingInfoOrganization.page = 1;
                this.fetchOrganization();
            },
            fetchOrganization() {
                instance
                    .get(RecordURL + "getlinksorganization", {
                        headers: authHeader(),
                        params: this.pagingInfoOrganization,
                    })
                    .then((response) => {
                        this.organizations = response.data.data;
                        this.totalitemsorg = response.data.count;
                    })
                    .catch(function (error) {
                        responseCheck(error.response.status);
                    });
            },
            searchEvents() {
                this.pagingInfoEvents.page = 1;
                this.fetchEvents();
            },
            fetchEvents() {
                instance
                    .get(RecordURL + "getlinksevents", {
                        headers: authHeader(),
                        params: this.pagingInfoEvents,
                    })
                    .then((response) => {
                        this.events = response.data.data;
                        this.totalitemsevents = response.data.count;
                    })
                    .catch(function (error) {
                        responseCheck(error.response.status);
                    });
            },
            sortev: function (sortBy) {
                if (sortBy === this.pagingInfoEvents.sortBy) {
                    this.pagingInfoEvents.reverse = !this.pagingInfoEvents.reverse;
                } else {
                    this.pagingInfoEvents.sortBy = sortBy;
                    this.pagingInfoEvents.reverse = false;
                }
                this.pagingInfoEvents.page = 1;
                this.fetchEvents();
            },
            searchFinancial() {
                this.pagingInfoFinancial.page = 1;
                this.fetchFinancial();
            },
            fetchFinancial() {
                instance
                    .get(RecordURL + "getlinksfinancial", {
                        headers: authHeader(),
                        params: this.pagingInfoFinancial,
                    })
                    .then((response) => {
                        this.financial = response.data.data;
                        this.totalitemsfinancial = response.data.count;
                    })
                    .catch(function (error) {
                        responseCheck(error.response.status);
                    });
            },
            searchFirearms() {
                this.pagingInfoFirearms.page = 1;
                this.fetchFireArms();
            },
            fetchFireArms() {
                instance
                    .get(RecordURL + "getlinksfirearm", {
                        headers: authHeader(),
                        params: this.pagingInfoFirearms,
                    })
                    .then((response) => {
                        this.firearms = response.data.data;
                        this.totalitemsfirearm = response.data.count;
                    })
                    .catch(function (error) {
                        responseCheck(error.response.status);
                    });
            },
            searchLegalCharges() {
                this.pagingInfoLegalCharges.page = 1;
                this.fetchLegalCharges();
            },
            fetchLegalCharges() {
                instance
                    .get(RecordURL + "getlinkslegalcharges", {
                        headers: authHeader(),
                        params: this.pagingInfoLegalCharges,
                    })
                    .then((response) => {
                        this.legalcharges = response.data.data;
                        this.totalitemslegalcharges = response.data.count;
                    })
                    .catch(function (error) {
                        responseCheck(error.response.status);
                    });
            },
            searchRealEstate() {
                this.pagingInfoRealEstates.page = 1;
                this.fetchRealEstates();
            },
            fetchRealEstates() {
                instance
                    .get(RecordURL + "getlinksrealestate", {
                        headers: authHeader(),
                        params: this.pagingInfoRealEstates,
                    })
                    .then((response) => {
                        this.realestate = response.data.data;
                        this.totalitemsrealestate = response.data.count;
                    })
                    .catch(function (error) {
                        responseCheck(error.response.status);
                    });
            },
            searchTelephone() {
                this.pagingInfoTelephone.page = 1;
                this.fetchTelephone();
            },
            fetchTelephone() {
                instance
                    .get(RecordURL + "getlinkstelephone", {
                        headers: authHeader(),
                        params: this.pagingInfoTelephone,
                    })
                    .then((response) => {
                        this.telephone = response.data.data;
                        this.totalitemstelephone = response.data.count;
                    })
                    .catch(function (error) {
                        responseCheck(error.response.status);
                    });
            },
            searchPapers() {
                this.pagingInfoPapers.page = 1;
                this.fetchPapers();
            },
            fetchPapers() {
                instance
                    .get(RecordURL + "getlinksofficialpapers", {
                        headers: authHeader(),
                        params: this.pagingInfoPapers,
                    })
                    .then((response) => {
                        this.papers = response.data.data;
                        this.totalitemspaper = response.data.count;
                    })
                    .catch(function (error) {
                        responseCheck(error.response.status);
                    });
            },
            searchTransportation() {
                this.pagingInfoTransportation.page = 1;
                this.fetchTransportation();
            },
            fetchTransportation() {
                instance
                    .get(RecordURL + "getlinkstransportation", {
                        headers: authHeader(),
                        params: this.pagingInfoTransportation,
                    })
                    .then((response) => {
                        this.transportation = response.data.data;
                        this.totalitemstransportation = response.data.count;
                    })
                    .catch(function (error) {
                        responseCheck(error.response.status);
                    });
            },
            responsecheck: function (status) {
                responseCheck(status);
            },
            sois: function (id) {
                this.soiId = id;
                this.showModal();
            },
            showModal: function () {
                this.$bvModal.show("soilists");
            },
            soidb: function (id, type) {
                this.soifromdb = "";

                instance
                    .get(RecordURL + "soidb?id=" + id + "&type=" + type, {
                        headers: authHeader(),
                    })
                    .then((response) => {
                        if (response.data.withsoi) {
                            this.soifromdb = response.data.data;
                            this.$bvModal.show("soifromdbs");
                        } else {
                            notifyHelper("warn", "SOI from database not found");
                        }
                    })
                    .catch(function (error) {
                        responseCheck(error.response.status);
                    });
            },
            deleteLink: function () {
                if (
                    prompt(
                        "this will delete all linkages of the entity! do you want to proceed?"
                    )
                ) {
                    let loaderfile = this.$loading.show();
                    instance
                        .get(RecordURL + "deleteLink?iD=" + this.pagingInfo.id, {
                            headers: authHeader(),
                        })
                        .then((response) => {
                            if (response.data.error) {
                                notifyHelper("warn", response.data.message);
                                loaderfile.hide();
                            } else {
                                notifyHelper("success", response.data.message);
                                loaderfile.hide();
                            }
                        })
                        .catch(function (error) {
                            responseCheck(error.response.status);
                        });
                }
            },
            deleteLinkSingle: function (id) {
                if (prompt("Are you sure you want to delete the link?")) {
                    let loaderfile = this.$loading.show();
                    instance
                        .get(RecordURL + "deleteLinkSingle?iD=" + id, {
                            headers: authHeader(),
                        })
                        .then((response) => {
                            if (response.data.error) {
                                notifyHelper("warn", response.data.message);
                                loaderfile.hide()
                            } else {
                                notifyHelper("success", response.data.message);
                                loaderfile.hide()
                            }
                        })
                        .catch(function (error) {
                            responseCheck(error.response.status)
                        })
                }
            },
        },
    };
</script>
